import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      extend: true,
    }),
  ],
  exports: [TranslateModule],
})
export class TranslationModule {
  constructor(
    private translate: TranslateService, // private dateAdapter: DateAdapter<any>
    private route: ActivatedRoute // private sharedService: SharedService
  ) {
    // Change with Language from query paerams
    this.route.queryParamMap.subscribe((params) => {
      const lang = params.get('lang')!;
      if (lang) {
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
      } else {
        this.translate.setDefaultLang('id');
        this.translate.use('id');
      }
    });
  }
}
